/* unplugin-vue-components disabled */import script from "./Common.vue?vue&type=script&setup=true&lang=js"
export * from "./Common.vue?vue&type=script&setup=true&lang=js"

import "./Common.vue?vue&type=style&index=0&id=3c212eb0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c212eb0"]])

export default __exports__